export default __webpack_public_path__ + "1f97f8c60f2730c9c33810c6ec0ba84f.svg";